import { value } from '@takeshape/util';
import { updateAuthentication } from "../util/authentication.js";
import { isCompleteGraphQLConfig } from "../util/config.js";
import { getHealthCheck } from "../util/health.js";
const title = 'Submarine';
const serviceProvider = {
    name: 'submarine',
    title,
    description: 'Build tailored experiences on top of Shopify Plus to delight customers, drive growth, and streamline operations.',
    categories: ['ecommerce'],
    links: [
        { title: 'Homepage', url: 'https://www.getsubmarine.com/' },
        { title: 'Docs', url: '/docs/services/providers/submarine' }
    ],
    serviceType: 'graphql',
    introspectionType: 'graphql',
    createId: value('graphql'),
    getFormSchema: value({
        type: 'object',
        required: ['title', 'id', 'namespace', 'authentication'],
        properties: {
            title: {
                title: 'Name',
                type: 'string',
                default: 'Submarine'
            },
            id: {
                title: 'Slug',
                type: 'string',
                pattern: '[0-9a-z_-]+',
                default: 'submarine'
            },
            namespace: {
                title: 'Namespace',
                type: 'string',
                pattern: '^[A-Z][A-Za-z]+$',
                default: 'Submarine'
            },
            authentication: {
                title: 'Authentication',
                description: 'The following properties are encrypted and are obscured on this form to ensure the security of your data.',
                type: 'object',
                properties: {
                    token: {
                        title: 'API Key',
                        type: 'string',
                        '@sensitive': true
                    }
                },
                required: ['token']
            }
        }
    }),
    getFormConfig: value({
        order: ['title', 'id', 'namespace', 'authentication'],
        properties: {
            title: {
                widget: 'singleLineText',
                instructions: 'A human-readable title for this service.'
            },
            id: {
                widget: 'singleLineText',
                instructions: 'The human-readable unique identifier for this service. Only lowercase letters, numbers, hyphen, and underscore are allowed.'
            },
            namespace: {
                widget: 'singleLineText',
                instructions: 'A namespace to use for any generated types or queries. For example, if you enter `Foo` your types will be named `Foo_Bar`.'
            },
            authentication: {
                properties: {
                    token: {
                        widget: 'sensitiveField',
                        instructions: 'You get your API Key in the Submarine app settings in your Shopify store account.'
                    }
                },
                order: ['token']
            }
        }
    }),
    getConfig(formData) {
        const config = {
            title: formData.title ?? title,
            namespace: formData.namespace ?? title,
            provider: 'submarine',
            serviceType: 'graphql',
            authenticationType: 'bearer',
            options: {
                endpoint: 'https://api.getsubmarine.com/graphql'
            }
        };
        return updateAuthentication(config, formData, { type: 'bearer' });
    },
    isCompleteConfig: isCompleteGraphQLConfig,
    getHealthCheck: getHealthCheck({ checkName: 'graphqlIntrospection' })
};
export default serviceProvider;
